import React, { useState, useEffect } from "react";
import { IGlobalPoprop } from "../../interfaces/global-interface";
import { IConteoInventario, ConteoInventarioError } from "../../interfaces/entrada-salida-interface";
import { getServiceData, saveServiceData } from "../../store/global-services";
import ButtonGST from "../../atoms/Controls/ButtonGTS";
import { StyledTableRow, StyledTableCell } from "../../atoms/tables/TableStyles";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Table, TableBody, TextField, TableContainer, TableHead, TableRow, FormControl, FormHelperText, InputLabel, Select, MenuItem, SelectChangeEvent, Stack, Pagination, Checkbox } from "@mui/material";
import { UrlSiteBase, formatDateFromStr } from '../../Global';
import { SwitchLabelGTS } from "../../atoms/Controls/SwitchGTS";
import { DialogGTS } from "../../molecules/DialogGTS";
let { UrlBase } = UrlSiteBase();
const ConteoInventario = (globalProp?: IGlobalPoprop) => {
    const { idDistribuidora } = useParams();
    const { idConteo } = useParams();
    const [idDistEditar, setIdDisEditar] = useState<string>(idDistribuidora || '0');
    const [productos, setProductos] = useState<any>([]);
    const [idTipoConteo, setIdTipoConteo] = useState<string>('0');
    const [idHorario, setIdHorario] = useState<string>('0');
    const [conteo, setConteo] = useState<IConteoInventario>();
    const [tiposConteo, setTiposConteo] = useState<any>([]);
    const [horarios, setHorarios] = useState<any>([]);
    const [observaciones, setObservaciones] = useState<string>('');
    const [motivoCancelacion, setMotivoCancelacion] = useState<string>('');
    const [isActive, setIsActive] = useState<boolean>(true);
    const [error, setError] = useState(ConteoInventarioError);
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const navigate = useNavigate();
    let idConteoState = 0;
    if (idConteo !== undefined)
        idConteoState = parseInt(idConteo, 10);
    const getConteoInventario = () => {
        if (tiposConteo.length === 0) 
            return;
        getServiceData({ 
            nombre: 'conteo-inventario', 
            id: idConteoState.toString(),
            parametros: idDistribuidora === undefined ? {} : { idDistribuidora: idDistribuidora }
        }).then(data => {
            if (data.success) {
                setIdDisEditar(data.conteo.idDistribuidora);
                setIdTipoConteo(data.conteo.idTipoConteo);
                setIdHorario(data.conteo.idHorario);
                setObservaciones(data.conteo.observaciones);
                setMotivoCancelacion(data.conteo.motivoCancelacion || '');
                setIsActive(data.conteo.estatus === 1);
                data.conteo.productos.forEach((prod: any) => {
                    prod.nombre = idConteoState === 0 ? prod.nombre : prod.producto;
                    prod.errorCantidadContenedor = '';
                    prod.cantidadContenedor = prod.cantidadContenedor || 0;
                    prod.cantidadSuelta = prod.cantidadSuelta || 0;
                    prod.cantidadExistente = prod.cantidadExistente || 0;
                    setCantidadEmpaqueTotal(prod);
                });
                setProductos(data.conteo.productos);
                setConteo(data.conteo);
                setTotalPages(data.pagination.last_page);
            }
        });
    }
    const getTiposConteo = () => {
        getServiceData({ nombre: 'tipos-conteo' }).then(data => {
            if (data.success) {
                setTiposConteo(data.tiposConteo);
            }
        });
    };
    const getHorarios = () => {
        getServiceData({ nombre: 'horarios' }).then(data => {
            if (data.success) {
                setHorarios(data.horarios);
            }
        });
    };
    useEffect(() => {
        getTiposConteo();
        getHorarios();
    }, []);
    useEffect(() => {
        if (tiposConteo.length > 0 && horarios.length > 0)
            getConteoInventario();
    }, [tiposConteo, horarios]);
    const setCantidadEmpaqueTotal = (row: any) => {
        row.cantidadEmpaqueTotal = (row.cantidadContenedor || 0) * row.capacidadContenedor + (row.cantidadSuelta || 0);
        
    };
    const handleSelectChange = (event: SelectChangeEvent<string>) => {
        const { name, value } = event.target;
        setIdTipoConteo(value);
        setError(error => ({ ...error, [name]: '' })); // Reset error for idTipoConteo
    };
    const handleSelectHorarioChange = (event: SelectChangeEvent<string>) => {
        const { name, value } = event.target;
        setIdHorario(value);
        setError(error => ({ ...error, [name]: '' })); // Reset error for idHorario
    };
    const handleInputTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = event.target;
        setObservaciones(value);
    }
    const handleInputTextChangeCancela = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = event.target;
        setMotivoCancelacion(value);
    }
    const handleCheckbox = () => {
        setIsActive(!isActive);
    }
    const handleCheckVerificado = (id: number) => {
        if (idConteoState > 0)
            return;
        productos?.map((prod: any) => {
            if (prod.id === id) {
                prod.verificado = !prod.verificado;
            }
        });
        setProductos([...productos]);
    };
    const handlePaginationChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };
    const guardarConteoInv = () => {
        productos.forEach((prod: any) => {
            if (!prod.verificado) {
                if (globalProp && globalProp.snackHandleOpen)
                    globalProp.snackHandleOpen({
                        open: true,
                        message: "Debe verificar todos los productos antes de guardar. " +
                            "Si alguna cantidad no coincide con la cantidad existente," + 
                            " sera necesario realizar el proceso de Venta, Salida y/o Entrada de inventario, " +
                            " segun corresponda.",
                        color: "red"
                    });
                return;
            }
        });
        saveServiceData({ reqMethod: 'PUT', nombre: 'conteo-inventario', datos : 
            { 
                id: idConteoState ?? 0,
                idDistribuidora: idConteoState === 0 ? idDistribuidora : conteo?.idDistribuidora,
                idTipoConteo: idTipoConteo,
                idHorario: idHorario,
                observaciones: observaciones,
                motivoCancelacion: isActive ? null : motivoCancelacion,
                productos: productos,
                estatus: isActive ? 1 : 2
            }
        }).then((data) => {
            if (data.success) {
                navigate(UrlBase + 'Conteo-Inventario');
                if (globalProp && globalProp.snackHandleOpen)
                    globalProp.snackHandleOpen({ open: true, message: data.message });
            }
            else {
                setError(ConteoInventarioError);
                for (const [key, value] of Object.entries(data.message)) {
                    setError(error => ({...error, [key]: value}));
                }
            }
        });
    };
    const getSafeValue = (field: any) => {
        return field === undefined || field === null ? '' : field;
    };
    return (
        <>
            <Box className="form-gst maximum" component="form" noValidate autoComplete="off">
                <div className="panel-inputs">
                    <div className="d-inline-flex p-2">
                        <div>
                            <div className="label">Distribuidora: {conteo?.distribuidora}</div>
                            <div className="label">Usuario: {conteo?.usuario}</div>
                        </div>
                    </div>
                    <FormControl className="select-control">
                        <InputLabel id="conteo-label">Tipo de conteo</InputLabel>
                        <Select labelId="tipo-conteo" id="tipo-conteo" name="idTipoConteo" value={idTipoConteo} label="Tipo de conteo" onChange={handleSelectChange}>
                            <MenuItem value={0}>Seleccione un tipo de conteo</MenuItem>
                            {tiposConteo?.map((tipoConteo: any) => (
                                <MenuItem key={tipoConteo.id} value={tipoConteo.id}>{tipoConteo.nombre}</MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{error.idTipoConteo}</FormHelperText>
                    </FormControl>
                    <FormControl className="select-control">
                        <InputLabel id="horario-label">Horario</InputLabel>
                        <Select labelId="horario-label" id="horario" name="idHorario" value={idHorario} label="Horario" onChange={handleSelectHorarioChange}>
                            <MenuItem value={0}>Seleccione un horario</MenuItem>
                            {horarios?.map((horario: any) => (
                                <MenuItem key={horario.id} value={horario.id}>{horario.nombre}</MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{error.idHorario}</FormHelperText>
                    </FormControl>
                    <div className="d-inline-flex p-2">
                        <div>
                            {idConteoState > 0 ? 
                            <>
                                <div className="label">Fecha de conteo al inventario: { formatDateFromStr(conteo?.fecha + "")}</div>
                                <FormControl className="check-control" error={error.estatus !== ''}>
                                    <SwitchLabelGTS label={isActive ? "Activo" : "Cancelado"} id="estatus" checked={isActive} onChange={handleCheckbox} />
                                </FormControl>
                            </>
                                : <></>
                            }
                        </div>
                    </div>
                    <TextField id="observaciones" className="medium-textarea" onChange={handleInputTextChange} multiline rows={2}
                            value={getSafeValue(observaciones)} label="Observaciones" color="secondary" error={error.observaciones !== ''}  helperText={error.observaciones} />
                    {idConteoState > 0 && !isActive ?
                        <>
                            <div className="d-inline-flex">
                                <div>
                                    <TextField id="motivoCancelacion" className="medium-textarea" onChange={handleInputTextChangeCancela} multiline rows={2}
                                        value={getSafeValue(motivoCancelacion)} label="Motivo de Cancelación" color="secondary" error={error.motivoCancelacion !== ''}  helperText={error.motivoCancelacion} />
                                </div>
                            </div>
                            <div className="d-inline-flex">
                                <div>
                                    <div className="label">Fecha de cancelación: { formatDateFromStr(conteo?.fechaCancela + "")}</div>
                                </div>
                            </div>
                        </>
                        : <></>
                    }
                </div>
            </Box>
            <TableContainer>
                <Table className="table-gts product-table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>ID</StyledTableCell>
                            <StyledTableCell>Producto</StyledTableCell>
                            <StyledTableCell align="center">Cantidad Contenedor</StyledTableCell>
                            <StyledTableCell align="center">Capacidad Contenedor</StyledTableCell>
                            <StyledTableCell align="center">Empaques Sueltos</StyledTableCell>
                            <StyledTableCell align="center">Empaques Totales</StyledTableCell>
                            <StyledTableCell align="center">Verificado</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {productos?.map((row: any) => (
                            <StyledTableRow key={row.id}>
                                <StyledTableCell>{row.id}</StyledTableCell>
                                <StyledTableCell>{row.nombre}</StyledTableCell>
                                <StyledTableCell align="center">
                                    {idConteo === undefined ? (
                                        <div>{Math.floor(row?.cantidadExistente / row?.capacidadContenedor)}</div>
                                    ) : (
                                        <div>{row?.cantidadContenedor}</div>
                                    )}
                                </StyledTableCell>
                                <StyledTableCell align="center">{row?.capacidadContenedor}</StyledTableCell>
                                <StyledTableCell align="center">
                                    {idConteo === undefined ? (
                                        <div>{row?.cantidadExistente % row?.capacidadContenedor}</div>
                                    ) : (
                                        <div>{row?.cantidadSuelta}</div>
                                    )}
                                </StyledTableCell>
                                {idConteo === undefined ? <StyledTableCell align="center">{row?.cantidadExistente}</StyledTableCell> 
                                : <StyledTableCell align="center">{(row?.cantidadContenedor * row?.capacidadContenedor) + row?.cantidadSuelta}</StyledTableCell>}
                                <StyledTableCell align="center">
                                    <FormControl className="check-control" error={error.errorVerificado !== ''}>
                                        <Checkbox id={`verificado-${row.id}`} checked={row.verificado == 1} onChange={() => handleCheckVerificado(row.id)} color="success" />
                                    </FormControl>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            { totalPages > 1 ?
                <Stack spacing={2}>
                    <Pagination count={totalPages} page={page} onChange={handlePaginationChange} />
                </Stack> 
                : <></>
            }
            <div className="panel-actions align-right">
                <ButtonGST onClick={() => navigate(UrlBase + 'Conteo-Inventario')}>{ idConteoState > 0 ? 'Cancelar Edición' : 'Cancelar Conteo' }</ButtonGST>
                <ButtonGST onClick={guardarConteoInv}>Guardar</ButtonGST>
            </div>
        </>
    );
};
export default ConteoInventario;